import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import LOGO from '../../assets/LOGO.png';

function NavBar() {
  return (
    <nav className="nav" style={{ background: 'rgba(17,17,17,0.98)', borderBottom: '1px solid #222', position: 'sticky', top: 0, zIndex: 100 }}>
      <Container maxWidth="lg" sx={{ display: 'flex', alignItems: 'center', py: 2 }}>
        <Link to="/">
          <img src={LOGO} alt="Happenings Logo" style={{ height: 38, marginRight: 24 }} />
        </Link>
        <Box sx={{ flexGrow: 1 }} />
        <Box sx={{ display: 'flex', gap: 3 }}>
          <Link to="/terms" style={{ color: '#f3f3f3', textDecoration: 'none', fontWeight: 500, fontSize: 16 }}>Terms</Link>
          <Link to="/privacy" style={{ color: '#f3f3f3', textDecoration: 'none', fontWeight: 500, fontSize: 16 }}>Privacy</Link>
        </Box>
      </Container>
    </nav>
  );
}

const SectionDivider = () => (
  <Divider sx={{ my: 5, borderColor: '#333', borderBottomWidth: 2, opacity: 0.5 }} />
);

const PrivacyPolicyPage = () => {
  return (
    <Box sx={{ minHeight: '100vh', width: '100vw', bgcolor: '#111', color: '#f3f3f3', pb: 10 }}>
      <NavBar />
      <Container maxWidth="md" sx={{ pt: 10, pb: 8 }}>
        <Typography variant="h2" sx={{ fontSize: { xs: '2.5rem', md: '4rem' }, fontWeight: 700, textAlign: 'center', mb: 2, letterSpacing: '-0.04em', lineHeight: 1.1 }}>
          Privacy Policy
        </Typography>
        <Typography variant="subtitle1" sx={{ color: '#ccc', textAlign: 'center', mb: 6, fontSize: { xs: '1rem', md: '1.25rem' } }}>
          Effective Date: May 29, 2025
        </Typography>
        <Typography variant="body1" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' }, color: '#e0e0e0', mb: 3, lineHeight: 1.7 }}>
          This Privacy Policy describes how Happenings Holdings Inc. (“Happenings”, “we”, “our”, or “us”) collects, uses, and discloses information when you use our event logistics and SaaS marketplace platform (the “Service”). This Policy applies to all users, including Hosts, Venues, Vendors, Sponsors, and Guests.
        </Typography>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          1. Information We Collect
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          We collect both personal and non-personal information to operate our platform effectively:
        </Typography>
        <ul style={{ marginLeft: 24, marginBottom: 24, color: '#e0e0e0', fontSize: '1.1rem' }}>
          <li>Account Data: Names, email addresses, company details, passwords</li>
          <li>Event Information: Event names, dates, budgets, and preferences</li>
          <li>Transaction Data: Booking details, pricing, services selected</li>
          <li>Payment Data: Managed through third-party processors (Stripe, etc.)</li>
          <li>Technical Data: IP address, device data, usage logs</li>
          <li>Communications: Messages and content exchanged through the platform</li>
        </ul>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          2. How We Use Your Information
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          Your data helps us:
        </Typography>
        <ul style={{ marginLeft: 24, marginBottom: 24, color: '#e0e0e0', fontSize: '1.1rem' }}>
          <li>Deliver and maintain the Service</li>
          <li>Facilitate interactions between users (e.g. booking venues, vendors)</li>
          <li>Manage billing and customer support</li>
          <li>Improve user experience through analytics</li>
          <li>Communicate updates, security notices, and marketing (where permitted)</li>
        </ul>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          3. Data Sharing and Disclosure
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          We do not sell personal data. We may share information with:
        </Typography>
        <ul style={{ marginLeft: 24, marginBottom: 12, color: '#e0e0e0', fontSize: '1.1rem' }}>
          <li>Event-related parties (e.g. venues, vendors) to fulfill a booking</li>
          <li>Third-party service providers (e.g. cloud hosting, analytics, payment)</li>
          <li>Law enforcement or regulatory bodies if legally required</li>
        </ul>
        <Typography variant="body2" sx={{ mb: 4, color: '#aaa', fontSize: '1rem' }}>
          Data shared with third parties will be limited to the purpose of delivering the services.
        </Typography>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          4. Your Rights
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          You may request to access, update, or delete your personal data. You can:
        </Typography>
        <ul style={{ marginLeft: 24, marginBottom: 24, color: '#e0e0e0', fontSize: '1.1rem' }}>
          <li>Update profile info in your account settings</li>
          <li>Contact us at <a href="mailto:team@happenings.dev" style={{ color: '#8b5cf6', textDecoration: 'underline' }}>team@happenings.dev</a> for data deletion</li>
          <li>Opt-out of marketing emails via unsubscribe links</li>
        </ul>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          5. Data Retention
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          We retain data for as long as necessary to:
        </Typography>
        <ul style={{ marginLeft: 24, marginBottom: 24, color: '#e0e0e0', fontSize: '1.1rem' }}>
          <li>Fulfill the purposes outlined in this policy</li>
          <li>Comply with legal obligations and audits</li>
          <li>Resolve disputes and enforce agreements</li>
        </ul>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          6. Security Measures
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          We implement technical and organizational security measures including:
        </Typography>
        <ul style={{ marginLeft: 24, marginBottom: 12, color: '#e0e0e0', fontSize: '1.1rem' }}>
          <li>SSL encryption for data in transit</li>
          <li>Role-based access control</li>
          <li>Regular vulnerability scans</li>
          <li>Monitoring for unauthorized access</li>
        </ul>
        <Typography variant="body2" sx={{ mb: 4, color: '#aaa', fontSize: '1rem' }}>
          While we strive to protect your data, no method of transmission is 100% secure.
        </Typography>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          7. Third-Party Integrations
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          Happenings may integrate with third-party services like payment processors, scheduling tools, or CRMs. These services have their own privacy policies. We are not responsible for their practices, and recommend you review their terms separately.
        </Typography>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          8. International Transfers
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          If you are outside the United States, your data may be transferred and processed in the U.S. By using the platform, you consent to this transfer.
        </Typography>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          9. Policy Changes
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          We may update this Privacy Policy periodically. If changes are material, we will notify users through the platform or by email. Continued use after changes constitutes acceptance.
        </Typography>
        <SectionDivider />
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' }, mb: 2 }}>
          10. Contact Us
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: '#e0e0e0', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          If you have questions or concerns about this Privacy Policy, please contact:
        </Typography>
        <Typography variant="body1" sx={{ color: '#8b5cf6', fontSize: { xs: '1.1rem', md: '1.2rem' } }}>
          Email: <a href="mailto:team@happenings.dev" style={{ color: '#8b5cf6', textDecoration: 'underline' }}>team@happenings.dev</a>
        </Typography>
      </Container>
    </Box>
  );
};

export default PrivacyPolicyPage; 